import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { ThemeConstantService } from '../shared/services/theme-constant.service';
import { WebService } from '../shared/services/web.service';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { environment } from 'src/environments/environment';
import {fadeIn,wipeOutRight} from '../../app/shared/animation/animation.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';

interface DataItem {
  popularity: string;
  resource_name: string;
  size: string;
  group_names: string[];
  uploaded_date: string;
  expires_date: string;
  category_name: string;
  tag: any;
  checked: any;
  position:any;
  is_shareable:boolean;
  index:number;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
  sortKey?: string;
  colWidth?:any;
  key?:string;
  Showsort?:boolean;
}

interface ResourceData {
  index: number;
  resource_id: string;
  resource_name: string;
  parent_folder: string | null;
  is_folder: boolean;
  resource_path: string;
  resource_url: string;
  resource_path_url: string;
  resource_thumbnail: string;
  size: number;
  is_active: boolean;
  document_notes: string;
  uploaded_date: string;
  expires_date: string;
  position: number;
  category_id: number;
  category_name: string;
  category_description: string;
  tag: { tag_id: string; tag_name: string }[];
  group_names: string[];
  is_deleted: boolean;
  mixedState?: boolean; // optional for mixed state
  checked?: boolean | false; // can be true, false, or 'indeterminate'
  is_shareable?:boolean // optional for shareable state
  
}

interface ResourceNode {
  resource_id: string;
  parent_id: string | null; // alias for parent_folder
  type: 'folder' | 'file' | 'image' | 'pdf' | 'url'; // you can derive this from extension if needed
  children?: string[]; // list of resource_ids
  data: ResourceData;
}

interface checkboxActionNode {
  resourceId: string;
  action: boolean; // true for checked, false for unchecked
}
interface FolderPaginationState {
  currentPage: number;
  totalPages: number;
  loadedResourceIds: string[]; // only resource_ids, not full data
  isLoading?: boolean;         // optional: if async
  isLastPage?: boolean;  
  nextPage?:number;      // optional: for UI disabling scroll
}
@Component({
  selector: 'data-listing',
  templateUrl: './data-listing.component.html',
  styleUrls: ['./data-listing.component.css'],
  animations:[fadeIn,wipeOutRight]
})
export class DataListingComponent implements OnInit, OnChanges {
  themeColors = this.colorConfig.get().colors;
  colorRed = this.themeColors.red;
  colorBlue = this.themeColors.blue;
  colorCyan = this.themeColors.cyan;
  colorGold = this.themeColors.gold;
  colorVolcano = this.themeColors.volcano;
  colorPurple = this.themeColors.purple;
  groupedResources: any[] = [];
  resourceDataRaw: any[] = [];
  filteredFiles: any;
  selectedRootFolder: any;
  checkedData: any[];
  anyChecked: any;
  allChecked: any;
  indeterminate: boolean;
  resourceService: any;
  router: any;
  isChecked: boolean = false;
  checkedItems: any[] = [];
  selectedItems: string[] = [];
  metadata: any;
  tagMetaData: any;
  resourceCategoryList: any[];
  resourceCategoryFilterList: any[];
  filteredResourceData: any[];
  selectedValue: string;
  selectedCategories: string[] = [];
  noMoreData: boolean = false;

  @Input() resourceData: any[] = [];
  @Input() selectedCategory: any;
  @Output() checkedItemsChanged: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  @Output() getDataFromChild: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedResourceIds: any;
  @Output() selectedResourceIdsChange = new EventEmitter<number[]>();

  @Input() initiallyCheckedResourceIds: number[];
  @Input() currentAccessGroupId: number;
  @ViewChild('scrollContainer') scrollContainerRef!: ElementRef;
  selectedFolder: any;
  iconVisible: boolean;
  navigationHistory: any = [];
  originalResourcesList: any[];
  filteredResourcess: any[];
  searchTerm: any = '';
  thumbnailBaseURL:string =  environment.BUCKET_URL;

  listOfColumns: ColumnItem[] = [
    {
      key:"position",
      Showsort: true,
      name: 'Order',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const nameA = a.index;
        const nameB = b.index;
        return nameA - nameB;
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '8%',
      // 100px
    },
    {
      key: 'resource_name',
      Showsort: true,
      name: 'Name',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const nameA = a.resource_name || '';
        const nameB = b.resource_name || '';
        return nameA.localeCompare(nameB);
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '30%',
    },

    // {
    //   name: 'Size',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) => {
    //     const nameA = a.size || '';
    //     const nameB = b.size || '';
    //     return nameA.localeCompare(nameB);
    //   },
    //   sortDirections: ['ascend', 'descend', null],
    // },
    {
      key: 'catgory_name',
      Showsort: true,
      name: 'Category',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const nameA = a.category_name || '';
        const nameB = b.category_name || '';
        return nameA.localeCompare(nameB);
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '15%',
    },
    {
      key: 'uploaded_date',
      Showsort: true,
      name: 'Uploaded',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const createdA = a.uploaded_date || '';
        const createdB = b.uploaded_date || '';
        const nameComparison = createdA.localeCompare(createdB);

        if (nameComparison !== 0) {
          return nameComparison;
        }

        const dateA = new Date(a.uploaded_date).getTime();
        const dateB = new Date(b.uploaded_date).getTime();

        return dateA - dateB;
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '15%',
    },
    // {
    //   name: 'Popularity',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) => {
    //     const nameA = a.popularity || '';
    //     const nameB = b.popularity || '';
    //     return nameA.localeCompare(nameB);
    //   },
    //   sortDirections: ['ascend', 'descend', null],
    // },

    {
      name: 'Share',
      Showsort: false,
      sortOrder: null,
      sortFn: null,
      sortDirections: ['ascend', 'descend', null],
      colWidth: '12%',
    },
    // {
    //   name: 'Tag',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) => {
    //     const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
    //     const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
    //     return tagA.localeCompare(tagB);
    //   },
    //   sortDirections: ['ascend', 'descend', null],
    //   colWidth: '15%',
    // },
    {
      name: 'Assignment',
      Showsort: false,
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const nameA = a.group_names.map((group)=> group).join(',') || '';
        const nameB = b.group_names.map((group)=> group).join(',') || '';
        return nameA.localeCompare(nameB);
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '20%',
    }
    
  ];
  filteredResourcessRaw: any[];
  parentFolderId: any;
  parentFolderIdResource: any = null;
  filteredResources: any;
  filterVisible: boolean;
  commercial: any;
  residential: any;
  competition: any;
  isLoading: boolean = false;
  showLoad: boolean = false;
  hasMore: boolean = true;
  resourceCache: Map<string, ResourceNode> = new Map();
  folderPaginationMap: Map<any, FolderPaginationState> = new Map();
  folderNavigationStack: string[] = [null]; // start at root
  folderIndexMap = new Map<number | null, number>();
  currentPage: number = 1;
  lastRequestTime: string = "";
  resourcesList: any[] = [];
  itemPerPage: number = 25; // Default items per page
  // Stack to track navigation history
  scrollPositionMap = new Map<string, number>(); // folderId -> scrollTop
  sortField: string | null = null;
  sortOrderR: 'asc' | 'desc' | null = null;

  checkboxActions = [];
  constructor(
    private colorConfig: ThemeConstantService,
    private webapi: WebService,
     private notification: NzNotificationService,
  ) {
    // this.getMetadata();
    // console.log("this is initially resoruce ids", this.initiallyCheckedResourceIds);
    // console.log("this is access group ids", this.currentAccessGroupId);
    // console.log("constructor resourceDAta", this.resourceData);
    // if(this.initiallyCheckedResourceIds.length > 0 && this.currentAccessGroupId ){

    //   this.getResources({ filters: [] });
    // }
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log("after all changes");
    if (
      changes['initiallyCheckedResourceIds']?.currentValue &&
      changes['currentAccessGroupId']?.currentValue
    ) {
      this.currentAccessGroupId = changes['currentAccessGroupId'].currentValue || null;
      this.initiallyCheckedResourceIds = changes['initiallyCheckedResourceIds'].currentValue || [];
      // ✅ Both inputs are ready — now trigger your API
      this.getResources({ filters: [] });
    }
    else{
      this.getResources({ filters: [] });

    }
  }
  ngOnInit() {
    console.log("ngOnInit it called")

    // console.log("this is initially resoruce ids", this.initiallyCheckedResourceIds);
    // console.log("this is access group ids", this.currentAccessGroupId);
    // console.log("constructor resourceDAta", this.resourceData);
    // if (this.initiallyCheckedResourceIds && this.currentAccessGroupId) {

    //   this.getResources({ filters: [] });
    // }
    
    this.filteredResourcess = cloneDeep(this.resourceData);
    this.filteredResourcessRaw = cloneDeep(this.resourceData);


    // Start from previous index or 0
    let currentIndex = this.folderIndexMap.get(this.parentFolderIdResource) ?? 0;

    // console.log("this is currentIndex", currentIndex);

    this.filteredResourcess.forEach((resource) => {
      resource['index'] = ++currentIndex;
    });

    // console.log("this is currentIndex after loop", currentIndex);
    // console.log("this is filteredResourcess After Indexing", this.filteredResourcess);

    // Save the updated index count
    this.folderIndexMap.set(this.parentFolderIdResource, currentIndex);

    // this.filteredResourcess.forEach((resource, index) => {
    //   resource['index'] = index + 1;
    // });

    this.resourceDataRaw = cloneDeep(this.filteredResourcess);
    
    let newResourceIds = [];
    const resp: any[] = [...this.filteredResourcess];
    resp.forEach((item) => {
      const isFolder = item.is_folder;
      const node: ResourceNode = {
        resource_id: item.resource_id,
        parent_id: item.parent_folder,
        type: isFolder ? 'folder' : 'file', // can expand with mime later
        children: isFolder ? [] : undefined, // we’ll fill this after fetching children
        data: item,
      };
      this.resourceCache.set(item.resource_id, node);
      newResourceIds.push(node.resource_id)
    })
    // console.log("this is newResourceIds", newResourceIds);
    // console.log("this is resourceCache", this.resourceCache);
    let totalPages = localStorage.getItem('totalResourceCount') ? Math.ceil(Number(localStorage.getItem('totalResourceCount')) / this.itemPerPage) : 1;
    // console.log("this is totalPages", totalPages);

    this.updatePagination(
      null,
      1,
      totalPages,
      newResourceIds
    );
    this.checkedItems = this.initiallyCheckedResourceIds || [];
    // this.filteredResourcess = this.resourceData.filter(
    //   (resource) => resource.parent_folder === null
    // );
    // console.log("this is filtered resource", this.filteredResourcess);
    // this.filteredResourcess.forEach((resource, index) => {
    //   resource['index'] = index + 1;
    // });

    // this.filteredResources = cloneDeep(this.filteredResourcess);
    // this.filteredResourcessRaw = this.filteredResourcess;
    // console.log("this is filtered resource", this.filteredResourcess);


  }

  getResources({ filters }, reqSource?): void {

    this.isLoading = true;
    this.showLoad = true;

    this.lastRequestTime = this.lastRequestTime ? this.lastRequestTime : localStorage.getItem("lastRequestTime");
    let currentLevelExistingResourceIds = this.folderPaginationMap.get(this.parentFolderIdResource)?.loadedResourceIds || [];
    // console.log("this is currentLevelExistingResourceIds", currentLevelExistingResourceIds);
    
    let sortObj = {};
    if (this.sortOrderR && this.sortField) {
      sortObj = {
        sortField: this.sortField,
        sortOrder: this.sortOrderR
      }
    }

    // console.log("this is sortObj", sortObj);
    const obj = {
      request_page: this.currentPage,
      items_per_page: this.itemPerPage,
      search: this.searchTerm ||  "",
      sort: sortObj ? sortObj : null,
      parent_id: this.parentFolderIdResource || null,
      timestamp: this.lastRequestTime || "",
      existing_resources: currentLevelExistingResourceIds || [],
      filters: filters.map((file) => {
        return {
          Key: file.key,
          Values: file.values,
        };
      }),
      access_group_id: this.currentAccessGroupId ? this.currentAccessGroupId : null,
      assigned_resource_ids: this.initiallyCheckedResourceIds ? this.initiallyCheckedResourceIds : []
    }
    //if search is not provided then set it to empty string
    if (!reqSource || reqSource !== 'search') {
      obj.search = ""

    }

    this.webapi
      .requestJson('getPaginatedResource', obj)
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
         
          this.resourcesList = [...response.data.data];
          if (this.resourcesList.length < this.itemPerPage) this.hasMore = false;

          // Start from previous index or 0
          // let currentIndex = this.folderIndexMap.get(obj.parent_id) ?? 0;

          // console.log("this is currentIndex", currentIndex);

          this.resourcesList.forEach((resource) => {
            // resource['index'] = ++currentIndex;
          });

          this.updateResourceCheckedState()
       

          // Save the updated index count
          // if (typeof obj.parent_id == 'string') {

          //   this.folderIndexMap.set(parseInt(obj.parent_id), currentIndex);
          // }
          // else {
          //   this.folderIndexMap.set(obj.parent_id, currentIndex);

          // }

          // console.log("this is folderIndexMap", this.folderIndexMap);

          const existingIds = new Set(this.folderPaginationMap.get(obj.parent_id)?.loadedResourceIds ?? []);

          const newResourceIds = [];

          if (this.currentPage === 1) {
            // If it's the first page, reset the filteredResourcess
            this.filteredResourcess = [];
            // this.filteredResourcess = [...this.resourcesList];

          }
          // else {
          //   //append new resource in filteredREsourcess

          //   // Deduplicate based on resource_id
          //   // Deduplicate and update loaded resource IDs for current folder
          //   const existingIds = new Set(this.folderPaginationMap.get(obj.parent_id)?.loadedResourceIds ?? []);
          //   const updatedIds = Array.from(new Set([...existingIds, ...newResourceIds]));
          //   this.folderPaginationMap.set(obj.parent_id, {
          //     ...this.folderPaginationMap.get(obj.parent_id),
          //     loadedResourceIds: updatedIds
          //   });

          // }


          // 🔹 Prepare tracking of new unique resource IDs
        

        

          const resp: any[] = [...this.resourcesList];

          resp.forEach((item) => {
            const isFolder = item.is_folder;
            const node: ResourceNode = {
              resource_id: item.resource_id,
              parent_id: item.parent_folder,
              type: isFolder ? 'folder' : 'file', // can expand with mime later
              children: isFolder ? [] : undefined, // we’ll fill this after fetching children
              data: item,
            };
            
            //set the file/folder to true if parent folder is checked
            let parentFolder = this.resourceCache.get(item.parent_folder)?.data;
            if (parentFolder &&  parentFolder.checked) {
              node.data.checked = true;
              node.data.mixedState = false; // reset mixed state if parent is checked

            }
            if(parentFolder && (!parentFolder.checked && !parentFolder.mixedState)){
              node.data.checked = false;
              node.data.mixedState = false; // reset mixed state if parent is unchecked
            }
            
            // Track new resource ID only if not seen before
            if (!existingIds.has(item.resource_id)) {
              newResourceIds.push(item.resource_id);
            }

            // Always update or replace in cache
            this.resourceCache.set(item.resource_id, node);

            // Deduplicate filteredResourcess
            if (!this.filteredResourcess.some(r => r.resource_id === item.resource_id)) {
              this.filteredResourcess.push(item);
            }
          })
         
          // console.log("this is resourceCache", this.resourceCache);
          let totalPages = Math.ceil(response.data.total_resources_count / this.itemPerPage);


          this.isLoading = false;
          this.showLoad = false;

          //Update pagination only when the search is empty

          if (!obj.search || obj.search == "" || obj.search == null) {
            
            console.log("Updating the pagination in the getResourcelist")
            
          this.updatePagination(
            obj.parent_id,
            obj.request_page,
            totalPages,
            newResourceIds
          );
        }
          if (obj.sort == null || Object.keys(obj.sort).length === 0) {
            //If no sort applied then sort by position
            // Update the filteredResourcess to reflect current folder's loaded resources
            this.filteredResourcess = this.filteredResourcess.sort((a, b) => a.position - b.position);
          }

          this.getDataFromChild.emit(this.resourceCache) 


          //set the total resource count in local storage
          localStorage.setItem('totalResourceCount', response.data.total_resources_count.toString());
          localStorage.setItem('lastRequestTime', response.data.timestamp.toString());
           
          this.currentPage = this.currentPage + 1;

        },
        (error) => {
          console.log('ERROR', error);
          // this.isLoading = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  updateResourceCheckedState() {

    //Convert 'checked' and 'unchecked' to true and false and add mixedState and assign true when its intermediate  other wise false
    this.resourcesList.forEach((item) => {
      if (item.checked === 'checked') {
        item.checked = true;
        item.mixedState = false;

      }
      if (item.checked === 'unchecked') {
        item.checked = false;
        item.mixedState = false;

      }
      //If checked is 'mixedState' then remove the 
      if (item.checked === 'indeterminate') {
        item.mixedState = true;
        item.checked = false;

      }

    });
    
    console.log("this is resourceList after checkState ", this.resourcesList)

  }
  // checkAll(value: boolean): void {
  //   this.checkedItems = [];
  //   this.resourceData.forEach((data) => {
  //     this.updateCheckedStateRecursive(data, value);
  //   });

  //   this.anyChecked = this.resourceData.some((e) => e.checked);

  //   this.allChecked = this.resourceData.every((e) => e.checked);

  //   this.checkedItemsChanged.emit(this.checkedItems);
  // }

  // updateCheckedStateRecursive(resource: any, value: boolean): void {
  //   resource.checked = value;

  //   if (resource.checked && !this.checkedItems.includes(resource.resource_id)) {
  //     this.checkedItems.push(resource.resource_id);
  //   } else if (!resource.checked) {
  //     const index = this.checkedItems.indexOf(resource.resource_id);
  //     if (index !== -1) {
  //       this.checkedItems.splice(index, 1);
  //     }
  //   }

  //   if (resource.is_folder) {
  //     const children = this.resourceData.filter(
  //       (item) => item.parent_folder === resource.resource_id
  //     );

  //     children.forEach((child) => {
  //       this.updateCheckedStateRecursive(child, value);
  //     });
  //   }
  // }

  // onCheckboxChange(resource: any): void {
  //   this.checkedItems = this.resourceData
  //     .filter((element) => element.checked)
  //     .map((element) => element.resource_id);

  //   if (resource.is_folder) {
  //     const children = this.resourceData.filter(
  //       (item) => item.parent_folder === resource.resource_id
  //     );

  //     if (resource.mixedState && resource.checked) {
  //       children.forEach((child) => {
  //         this.updateCheckedStateRecursive(child, true);
  //       });

  //       resource.mixedState = false;
  //     } else {
  //       children.forEach((child) => {
  //         this.updateCheckedStateRecursive(child, resource.checked);
  //       });
  //     }

  //     this.updateParentCheckedState(resource.parent_folder);
  //   }

  //   this.checkedItemsChanged.emit(this.checkedItems);

  //   this.anyChecked = this.resourceData.some((e) => e.checked);

  //   this.allChecked = this.resourceData.every((e) => e.checked);
  // }

  // updateParentCheckedState(parentFolderId: any): void {
  //   const parentFolder = this.resourceData.find(
  //     (item) => item.resource_id === parentFolderId
  //   );

  //   if (parentFolder) {
  //     const hasUncheckedChild = this.resourceData.some(
  //       (item) => item.parent_folder === parentFolderId && !item.checked
  //     );

  //     const hasCheckedChild = this.resourceData.some(
  //       (item) => item.parent_folder === parentFolderId && item.checked
  //     );

  //     const mixedState = hasUncheckedChild && hasCheckedChild;

  //     parentFolder.mixedState = mixedState;

  //     if (!mixedState) {
  //       parentFolder.checked = hasCheckedChild;
  //     }

  //     const index = this.checkedItems.indexOf(parentFolderId);
  //     if (parentFolder.checked && index === -1) {
  //       this.checkedItems.push(parentFolderId);
  //     } else if (!parentFolder.checked && index !== -1) {
  //       this.checkedItems.splice(index, 1);
  //     }

  //     this.updateParentCheckedState(parentFolder.parent_folder);
  //   }
  // }

  // private updateCheckedState(resource: any): void {
  //   if (Array.isArray(resource.children) && resource.children.length > 0) {
  //     resource.children.forEach((child) => {
  //       child.checked = resource.checked;

  //       if (child.checked) {
  //         this.checkedItems.push(child.resource_id);
  //       } else {
  //         const index = this.checkedItems.findIndex(
  //           (item) => item === child.resource_id
  //         );
  //         if (index !== -1) {
  //           this.checkedItems.splice(index, 1);
  //         }
  //       }

  //       this.updateCheckedState(child);
  //     });
  //   }
  // }

  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }
  checkAll(value: boolean): void {
    this.checkedItems = [];

    this.filteredResourcess.forEach((data) => {

      this.checkboxActions.push({
        resourceId: data.resource_id,
        action: value ? true : false
      });

      if (data.mixedState) {
        // If the resource is in mixed state, check it regardless of the specified value
        this.updateCheckedStateRecursive(data, value);
      } else {
        // Otherwise, use the specified value
        this.updateCheckedStateRecursive(data, value);
      }
    });
    let parent_folder_id = null;
    parent_folder_id = this.filteredResourcess[0]?.parent_folder;
    parent_folder_id && this.updateParentCheckedState(parent_folder_id);
    // this.parentFolderIdResource && this.updateParentCheckedState(this.parentFolderIdResource);

    this.filteredResourcess = this.getParentResource(parent_folder_id);

    // this.filteredResourcess = this.getParentResource(this.parentFolderIdResource);
    // this.filteredResourcess = this.resourceData.filter((resource)=> resource.parent_folder === this.parentFolderIdResource)

    this.checkedItemsChanged.emit([this.checkedItems, this.checkboxActions]);
    
    this.anyChecked = this.filteredResourcess.some((e) => e.checked);

    this.allChecked = this.filteredResourcess.every((e) => e.checked);
   

    if (this.allChecked) {
      this.indeterminate = false;
    }
    else {
      this.indeterminate = this.anyChecked && !this.allChecked;
    }

    console.log("This is checkboxActions in checkAll", this.checkboxActions);
  }

  updateCheckedStateRecursive(resource: any, value: boolean): void {
    resource.checked = value;
    resource.mixedState = false;

    // If the resource is checked(true), add its ID to the checkedItems array
    if (resource.checked && !this.checkedItems.includes(resource.resource_id)) {
      this.checkedItems.push(resource.resource_id);
    }
    // if the resource is unchecked, remove its ID from the checkedItems array
    else if (!resource.checked) {
      const index = this.checkedItems.indexOf(resource.resource_id);
      if (index !== -1) {
        this.checkedItems.splice(index, 1);
      }
    }
    //In case of Folder, fetch all the IDs and store it in the children variable
    if (resource.is_folder) {

      const folderState = this.folderPaginationMap.get(resource.resource_id);
      const visibleIds = folderState?.loadedResourceIds ?? [];
      const tableData = visibleIds.map(id => this.resourceCache.get(id)?.data).filter(Boolean);

      console.log("this is tableData===>", tableData);
      
      const children = tableData || [];
      // const children = this.resourceData.filter(
      //   (item) => item.parent_folder === resource.resource_id
      // );
      //Now pass the resourceData and the value to this function recursively to perform above process    
      children.forEach((child) => {
        this.updateCheckedStateRecursive(child, value);
      });
    }
  }
  resetResourceCache(){
    console.log("resetResourceCache is called");
    this.resourceCache.clear();
    this.folderPaginationMap.clear();
    this.folderIndexMap.clear();
    this.folderNavigationStack = [null]; // Reset to root
    this.scrollPositionMap.clear();
    this.currentPage = 1;
    this.lastRequestTime = "";
    this.resourcesList = [];
    this.filteredResourcess = [];
    this.filteredResourcessRaw = [];
    this.checkedItems = [];
    this.anyChecked = false;
    this.allChecked = false;
    this.selectedRootFolder = null;
    this.parentFolderIdResource = null;

  }
  onCheckboxChange(resource: any): void {
    console.log("This is that resource",resource)

    //Update all the action in the array and send this array to backend api
    this.checkboxActions.push({
      resourceId: resource.resource_id,
      action: resource.checked ? true : false
    })

    console.log("This is checkboxActions in onCheckboxchange", this.checkboxActions);
    let currentResource = this.resourceCache.get(resource.resource_id)?.data;
    if (currentResource) {
      currentResource.checked = resource.checked;
      // currentResource.mixedState = false;
    }
  


    if (resource.checked) {
        this.checkedItems.push(resource.resource_id);
    } else {
      //Found the resource Ids in checkedItems
      const index = this.checkedItems.indexOf(resource.resource_id);

      //If found, remove it from the checkedItems array
      if (index !== -1) {
        this.checkedItems.splice(index, 1);
      }
    }
    //If folder then update all the nested childs
    if (resource.is_folder) {

      // //If resource are loaded then update the checked state of all children
      // console.log("this is current resource_id", resource.resource_id);
      // console.log("this is folder pagination map", this.folderPaginationMap);

      const folderState = this.folderPaginationMap.get(resource.resource_id);
      // console.log("this is folderState", folderState);

      const visibleIds = folderState?.loadedResourceIds ?? [];
      //Get all children
      const tableData = visibleIds.map(id => this.resourceCache.get(id)?.data).filter(Boolean);

      if(tableData.length > 0){

        if (resource.mixedState && resource.checked) {        
          tableData.forEach((child) => {
            // Update the checked state of each child based on the resource's checked state
            this.updateCheckedStateRecursive(child, true);
          });
          resource.mixedState = false;
        } else {
          // If the resource is checked, update all children to match the checked state
          tableData.forEach((child) => {
            // Update the checked state of each child based on the resource's checked state
            this.updateCheckedStateRecursive(child, resource.checked);
          });
          // this.updateParentCheckedState(resource.parent_folder);
        }
      }
      else{
        //If resource is mixedState and checked are true but No children loaded yet then just simple checked the UI to true
        if (resource.mixedState && resource.checked){
          let currentResource = this.resourceCache.get(resource.resource_id)?.data;
          if(currentResource){
            currentResource.checked = true;
            currentResource.mixedState = false;
          }
          console.log("aFter checked  ===>", currentResource)
        }
      }


      // const children = this.resourceData.filter(
      //   (item) => item.parent_folder === resource.resource_id
      // );

      
      // if (resource.mixedState && resource.checked) {
      //   children.forEach((child) => {
      //     this.updateCheckedStateRecursive(child, true);
      //   });

      //   resource.mixedState = false;
      // } else {
      //   children.forEach((child) => {
      //     this.updateCheckedStateRecursive(child, resource.checked);
      //   });
      // }
      
      
      //// this.updateParentCheckedState(resource.parent_folder);
    }

    //Update the parent recursively upto root level
    this.updateParentCheckedState(resource.parent_folder);

    this.checkedItemsChanged.emit([this.checkedItems, this.checkboxActions]);

    console.log("this is filteredResourcess Inside onCheckboxChange", this.filteredResourcess);
    this.anyChecked = this.filteredResourcess.some((e) => e.checked);
    console.log("this is anyChecked in oncheckboxchange", this.anyChecked);
    this.allChecked = this.filteredResourcess.every((e) => e.checked);

    // if(this.allChecked){
    //   this.indeterminate = false;
    // }
    // else{
    //   this.indeterminate = this.anyChecked && !this.allChecked;
    // }
  }
  getParentResource(resourceId){
    const folderState = this.folderPaginationMap.get(resourceId);
    console.log("this is folderState", folderState);
    const visibleIds = folderState?.loadedResourceIds ?? [];
    const tableData = visibleIds.map(id => this.resourceCache.get(id)?.data).filter(Boolean);
    return tableData || []

  }
  updateParentCheckedState(parentFolderId: any): void {
    // const parentFolder = this.resourceData.find(
    //   (item) => item.resource_id === parentFolderId
    // );

    const parentFolder = this.resourceCache.get(parentFolderId)?.data;
    
    console.log("this is parentFolder", parentFolder);
    
    if (parentFolder) {

      const parentFolderResource = this.getParentResource(parentFolderId);
      console.log("this is parentFolderResource", parentFolderResource);

      const hasUncheckedChild = parentFolderResource.some(
        (item) => !item.checked
      );

      const hasCheckedChild = parentFolderResource.some(
        (item) =>  item.checked
      );
      const hasMixedStateChild = parentFolderResource.some((item) => item.mixedState)

      const mixedState = (hasUncheckedChild && hasCheckedChild) || hasMixedStateChild;

      parentFolder.mixedState = mixedState;

      if (!mixedState) {
        parentFolder.checked = hasCheckedChild;
      }else {
        parentFolder.checked = false;
      }

      const index = this.checkedItems.indexOf(parentFolderId);
      if (parentFolder.checked && index === -1) {
        this.checkedItems.push(parentFolderId);
      } else if (!parentFolder.checked && index !== -1) {
        this.checkedItems.splice(index, 1);
      }
       console.log("this is parentFolder ", parentFolder)


      this.updateParentCheckedState(parentFolder.parent_folder);
    }
  }

 

  onCheckboxSelectionChange(selectedIds: number[]) {
    this.selectedResourceIdsChange.emit(selectedIds);
  }

  // getMetadata(): void {
  //   this.webapi
  //     .requestJson('getMetaData', {
  //       metadata: ['group_tags', 'resource_category'],
  //     })
  //     .subscribe(
  //       (data) => {
  //         let response = JSON.parse(data.body);

  //         this.metadata = cloneDeep(response.data);

  //         if (this.metadata.resourceCategory) {
  //           this.tagMetaData = this.metadata.resourceCategory;

  //           this.resourceCategoryList = [...this.tagMetaData];
  //           this.resourceCategoryFilterList = [];
  //           this.resourceCategoryList.forEach((element) => {
  //             this.resourceCategoryFilterList.push({
  //               text: element.name,
  //               value: element.resource_category_id,
  //               byDefault: false,
  //             });
  //           });
  //         }
  //       },
  //       (error) => {
  //         var msg = error.headers.get('message');
  //       }
  //     );
  // }

  changeCategory() {
    if (this.selectedCategories.length === 0) {
      this.resourceData = [...this.resourceDataRaw];
    } else {
      this.resourceData = this.resourceDataRaw.filter((item) =>
        this.selectedCategories.includes(item.category_id)
      );
    }
  }

  goBack(): void {
    
    this.searchTerm = ''
    
    this.cancelFilter()
    if (this.folderNavigationStack.length > 1) {
      this.folderNavigationStack.pop();
      console.log("this is folder navigation", this.folderNavigationStack)
      this.parentFolderIdResource = this.folderNavigationStack[this.folderNavigationStack.length - 1];
      // Reset to first page when navigating back according pagination map stack
      let currentPaginationState = this.folderPaginationMap.get(this.parentFolderIdResource);
      this.currentPage = currentPaginationState?.currentPage || 1;

      this.hasMore = currentPaginationState.currentPage < currentPaginationState.totalPages;
      this.renderData(() => {
        // After DOM is updated, restore scroll
        setTimeout(() => {
          const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
          this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
        }, 0); // adjust delay if necessary
      });
    }
    else {
      // this.folderNavigationStack = ["null"];
      console.log("this is folder else navigation", this.folderNavigationStack)
      this.parentFolderIdResource = null;
      // Reset to first page when navigating back according pagination map stack
      let currentPaginationState = this.folderPaginationMap.get(this.parentFolderIdResource);
      this.currentPage = currentPaginationState?.currentPage || 1;

      this.hasMore = currentPaginationState.currentPage < currentPaginationState.totalPages;
      this.renderData(() => {
        // After DOM is updated, restore scroll
        setTimeout(() => {
          const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
          this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
        }, 0); // adjust delay if necessary
      });

    }



    // if (this.navigationHistory.length > 0) {
    //   const previousState = this.navigationHistory.pop();
      
    //   if(this.anyChecked){
    //   this.initializeFolderWithParentId(previousState.parentFolderId)     

    //   }
    //   this.filteredResourcess = previousState.filteredResourcess; 

        
    // }
    // if(this.navigationHistory.length === 0){

    //   //set null to root folder state
    //   this.parentFolderIdResource = null;
      
    //   //for Rootfolder 
    //   this.initializeFolderWithParentId(null)     

    // }
    // this.handleAllCheckstate(this.filteredResourcess) 
    
    
  }

  displayFiles(item: any): void {
    // if (!isNaN(item.resource_id) && item.is_folder === 1) {
    //   this.parentFolderIdResource = item.resource_id;
    //   this.navigationHistory.push({
    //     filteredResourcess: this.filteredResourcess,
    //     parentFolderId: item.resource_id,
    //   });

    //   this.filteredResourcess = this.resourceData.filter(
    //     (resource) => resource.parent_folder === item.resource_id
    //   );
    // } else {
    const scrollTop = this.scrollContainerRef.nativeElement.scrollTop;
    this.scrollPositionMap.set(this.selectedRootFolder, scrollTop);
    this.searchTerm='';
      if(!isNaN(item.resource_id) && item.is_folder === 0){

        this.goBack();
      }
    // }
    
    console.log("this is data====>>>", this.filteredResourcess)
  }

  displayFolder(item: any): void {
    this.cancelFilter();
    
    this.hasMore = this.folderPaginationMap.has(item.resource_id || null) ? !this.folderPaginationMap.get(item.resource_id).isLastPage : true;
    this.searchTerm = '';
    const scrollTop = this.scrollContainerRef.nativeElement.scrollTop;
    this.scrollPositionMap.set(this.selectedRootFolder, scrollTop);
    
    if (!isNaN(item.resource_id) && item.is_folder === 1) {
      this.parentFolderIdResource = item.resource_id;
      console.log("this is parentFolderIdResource", this.parentFolderIdResource);
      this.goToFolder(item.resource_id);

      const isAlreadyCached = this.folderPaginationMap.has(this.parentFolderIdResource);
      console.log("this is folderPaginationMap", this.folderPaginationMap);

      if(isAlreadyCached){
        console.log("yes data is available in cache");
        this.renderData(() => {
          // After DOM is updated, restore scroll
          setTimeout(() => {
            const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
            this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
          }, 0); // adjust delay if necessary
        });
      }
      else{
        console.log('need to call api for folder data');
        // this.loadNextPage()
        this.currentPage = 1;
        this.getResources({ filters: [] });
      }

      this.handleAllCheckstate(this.filteredResourcess)
    } 

    // if (!isNaN(item.resource_id) && item.is_folder === 1) {
    //   this.parentFolderIdResource = item.resource_id;
    //   this.navigationHistory.push({
    //     filteredResourcess: this.filteredResourcess,
    //     parentFolderId: item.resource_id,
    //   });
    //   console.log("this is item resource id", this.navigationHistory);

    //   this.filteredResourcess = this.resourceData.filter(
    //     (resource) => resource.parent_folder === item.resource_id
    //   );
    //   this.filteredResourcess.forEach((resource, index) => {
    //     resource['index'] = index + 1;
    //   });
    //   this.handleAllCheckstate(this.filteredResourcess)
    // } 

  }

  //Get the current folder ID from the navigation stack
  getCurrentFolderId(): string {
    if (!this.folderNavigationStack || this.folderNavigationStack.length === 0) {

      return this.folderNavigationStack[this.folderNavigationStack.length - 1];
    }
    else {
      return  null;
    }
  }

  //Go to the folder and push the folderId to the stack
  goToFolder(folderId: string | null) {
    if (!this.folderNavigationStack) {
      this.folderNavigationStack = [];
    }

    const idToPush = folderId ?? null;
    this.folderNavigationStack.push(idToPush);

  }

  //Update the pagination when user navigating to the folder
  updatePagination(folderId: any, page: number, totalPages: number, newResourceIds: string[]) {
    const current = this.folderPaginationMap.get(folderId);
 

    const updated = {
      currentPage: page,
      totalPages,
      nextPage: page < totalPages ? page + 1 : null,
      loadedResourceIds: current
        ? [...current.loadedResourceIds, ...newResourceIds]
        : [...newResourceIds],
      isLastPage: page >= totalPages,
    };
    this.folderPaginationMap.set(folderId, updated);
    console.log("this is updated folderPaginationMap", this.folderPaginationMap);
  }

  //Render data to table
  renderData(callback?: () => void): void {
    this.isLoading = true;
    console.log("this is display folder function called");
    let currentFolderId = this.folderNavigationStack[this.folderNavigationStack.length - 1];
    console.log("this is currentFolder Id", currentFolderId);
    if (!currentFolderId) {
      currentFolderId = this.parentFolderIdResource || null;
    }
    this.parentFolderIdResource = currentFolderId;
    console.log("this is selectedRootFolder", this.parentFolderIdResource);

    console.log("this is folder pagination map", this.folderPaginationMap);
    const folderState = this.folderPaginationMap.get(currentFolderId);
    console.log("this is folderState", folderState);
    const visibleIds = folderState?.loadedResourceIds ?? [];
    const tableData = visibleIds.map(id => this.resourceCache.get(id)?.data).filter(Boolean);
   
    // this.filteredResourcess = tableData.map((resource) => {
    //   if (this.initiallyCheckedResourceIds.includes(parseInt(resource.resource_id))) {
    //     return { ...resource, checked: true };
    //   }
    //   else {
    //     return resource;
    //   }
    // })
    //sort the tabledata based on index
    tableData.sort((a, b) => a.index - b.index);
    
   // reset the indexing of filteredresourcess
    this.filteredResourcess = tableData.map((resource, index) => {
      return { ...resource, index: index + 1 };
    });
    console.log("this is filteredREsourcess", this.filteredResourcess)
    
    this.handleAllCheckstate(this.filteredResourcess)
    this.isLoading = false;
    callback();

  }

  pushFilesAndSubfolders(folder: any): void {
    if (folder.children && folder.children.length > 0) {
      folder.children.forEach((child) => {
        child.checked = true;
        this.checkedItems.push(child.resource_id);

        if (child.is_folder) {
          this.pushFilesAndSubfolders(child);
        }
      });
    }
  }
  getFileIcon(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();

    switch (fileExtension) {
      case 'pdf':
        return 'file-pdf';
      case 'doc':
      case 'docx':
        return 'file-word';
      case 'xls':
      case 'xlsx':
        return 'file-excel';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'file-image';
      case 'mp4':
      case 'mov':
      case 'avi':
        return 'file';
      
      default:
        return 'file-unknown';
    }
  }

  getMoreTagsContent(tags): string[] {
    return tags.slice(2).map((tag) => tag.tag_name);
  }

  moreTagsContent: string[];

  updateMoreTagsContent(tags): void {
    this.moreTagsContent = this.getMoreTagsContent(tags);
  }

  resetMoreTagsContent(): void {
    this.moreTagsContent = [];
  }

  initializeRootFilteredResources(): void {

    this.filteredResourcess = [...this.filteredResourcessRaw];
    this.filteredResourcess.forEach((resource, index) => {
      resource['index'] = index + 1;
    });
  }

  initializeFolderFilteredResources(parentFolderId: number): void {
    // this.filteredResourcess = this.resourceData.filter(
    //   (resource) => resource.parent_folder === parentFolderId
    // );

    //Store All Checked resource items before initialize
    let CheckedResourceData = this.resourceData.map((resource)=>{
      if(this.checkedItems.includes(resource.resource_id)){
        return {...resource,checked:true}
      }
      else{
        return resource
      }
    })
    //Now Filter the items based on folder parentID/specific folder with checkeditems
    this.filteredResourcess = CheckedResourceData.filter((resource)=> resource.parent_folder === parentFolderId)
    this.filteredResourcess.forEach((resource, index) => {
      resource['index'] = index + 1;
    });
  }

  onKeyUp(query: string): void {
    if (query) {
      const q: string = query.toLowerCase();

      //Find in the specific Folders
      // const searchData = this.filteredResources.filter((d) => {

      //Find across all folders
      const searchData = this.resourceData.filter((d) => {
        // const nameMatches =
        //   d.resource_name && d.resource_name.toLowerCase().includes(q);
        // return nameMatches;
        return this.resourceMatchesSearchTerm(d,q)
      });
      this.filteredResourcess = searchData;
    } else {
      if (this.parentFolderIdResource !== null) {
        this.initializeFolderFilteredResources(this.parentFolderIdResource);
      } else {
        // this.filteredResourcess = this.filteredResourcessRaw;

        let DefaultData= this.resourceData.map((resource)=>{
          if(this.checkedItems.includes(resource.resource_id)){
            return {...resource, checked: true};
          }
          else{
            return resource;
          }
        })

        this.filteredResourcess = DefaultData.filter(
          (resource) => resource.parent_folder === null
        );
      }
    }
  }

  resourceMatchesSearchTerm(resource: any, query:string): boolean {

    return (
      resource.resource_name.toLowerCase().includes(query) ||
      // (resource.size &&
      //   resource.size.toLowerCase().includes(query)) ||
      // (resource.size &&
      //   resource.size.toString().toLowerCase().includes(query)) ||
      (resource.uploaded_date &&
        resource.uploaded_date
          .toString()
          .toLowerCase()
          .includes(query)) ||
      (resource.category_name &&
        resource.category_name.toLowerCase().includes(query)) ||
        this.groupMatchSearchTerm(resource.group_names, query) ||
      this.tagsMatchSearchTerm(resource.tag,query)
    );
  }

  tagsMatchSearchTerm(tag: any[], query:string): boolean {
    return tag.some((tag) =>
      tag.tag_name.toLowerCase().includes(query)
    );
  }
  //assignment field search function
  groupMatchSearchTerm(groups: any[],query:string): boolean {
    return groups.some((group) =>
    group.toLowerCase().includes(query)
    );
  }


  resetSearch(){
    this.searchTerm = '';
    this.renderData(() => {
      // After DOM is updated, restore scroll
      setTimeout(() => {
        const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
        this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
      }, 0); // adjust delay if necessary
    });



    // if(this.searchTerm){
    //   this.searchTerm = '';
    //   // Reset `filteredResourcess` to the initial state
    //   if (this.parentFolderIdResource !== null) {
    //     this.initializeFolderFilteredResources(this.parentFolderIdResource);
    //   } else {
    //     // this.filteredResourcess = this.filteredResourcessRaw;

    //     //passing the null value to rest the root folder
    //     this.initializeFolderWithParentId(null)
       
    //   }

    // }
    
  }



  //after clearing the searchbox initialize the current folder with checked items and others options too
  initializeFolderWithParentId(parentId: number | null){

    let DefaultData= this.resourceData.map((resource)=>{
      if(this.checkedItems.includes(resource.resource_id)){
        return {...resource, checked: true};
      }
      else{
        return resource;
      }
    })

    this.filteredResourcess = DefaultData.filter(
      (resource) => resource.parent_folder === parentId
    );

  }

  handleAllCheckstate(currentResourceData){
    this.allChecked = currentResourceData.length > 0 && currentResourceData.every((e) => e.checked);
    console.log("handle function called",this.allChecked);
    this.anyChecked = currentResourceData.length > 0 && currentResourceData.some((e) => e.checked);
    // if(this.allChecked){
    //   this.indeterminate = false;
    // }
    // else{
    //   this.indeterminate = this.anyChecked && !this.allChecked;
    // }

  }

  cancelFilter() {
    this.residential = this.originalResidential;
    this.commercial = this.originalCommercial;
    this.competition = this.originalCompetition;
    this.filterVisible = false;
  }

  originalResidential = false;
  originalCommercial = false;
  originalCompetition = false;

  // applyFilters() {
  //   this.originalResidential = this.residential;
  //   this.originalCommercial = this.commercial;
  //   this.originalCompetition = this.competition;
  //   if (this.residential && this.commercial && this.competition) {

  //     this.filteredResourcess = this.filteredResourcessRaw.filter(
  //       (resource) =>
  //         resource.category_id === 1 ||
  //         resource.category_id === 2 ||
  //         resource.category_id === 3
  //     );
  //   } else if (this.residential && this.commercial) {
  //     this.filteredResourcess = this.resourceData.filter(
  //       (resource) => resource.category_id === 1 || resource.category_id === 2
  //     );
  //   } else if (this.residential && this.competition) {
  //     this.filteredResourcess = this.resourceData.filter(
  //       (resource) => resource.category_id === 1 || resource.category_id === 3
  //     );
  //   } else if (this.commercial && this.competition) {
  //     this.filteredResourcess = this.resourceData.filter(
  //       (resource) => resource.category_id === 2 || resource.category_id === 3
  //     );
  //   } else if (this.residential) {
  //     this.filteredResourcess = this.resourceData.filter(
  //       (resource) => resource.category_id === 1
  //     );
  //   } else if (this.commercial) {
  //     this.filteredResourcess = this.resourceData.filter(
  //       (resource) => resource.category_id === 2
  //     );
  //   } else if (this.competition) {
  //     this.filteredResourcess = this.resourceData.filter(
  //       (resource) => resource.category_id === 3
  //     );
  //   } else {
  //     this.filteredResourcess = this.resourceData;
  //   }

  //   this.filterVisible = false;
  // }

  applyFilters() {
    this.originalResidential = this.residential;
    this.originalCommercial = this.commercial;
    this.originalCompetition = this.competition;
    const currentLevelData = this.getParentResource(this.parentFolderIdResource);
    if (this.residential && this.commercial && this.competition) {


      this.filteredResourcess = currentLevelData.filter(
        (resource) =>
          resource.category_id === 1 ||
          resource.category_id === 2 ||
          resource.category_id === 3
      );
    } else if (this.residential && this.commercial) {
      this.filteredResourcess = currentLevelData.filter(
        (resource) => resource.category_id === 1 || resource.category_id === 2
      );
    } else if (this.residential && this.competition) {
      this.filteredResourcess = currentLevelData.filter(
        (resource) => resource.category_id === 1 || resource.category_id === 3
      );
    } else if (this.commercial && this.competition) {
      this.filteredResourcess = currentLevelData.filter(
        (resource) => resource.category_id === 2 || resource.category_id === 3
      );
    } else if (this.residential) {
      this.filteredResourcess = currentLevelData.filter(
        (resource) => resource.category_id === 1
      );
    } else if (this.commercial) {
      this.filteredResourcess = currentLevelData.filter(
        (resource) => resource.category_id === 2
      );
    } else if (this.competition) {
      this.filteredResourcess = currentLevelData.filter(
        (resource) => resource.category_id === 3
      );
    } else {
      this.filteredResourcess = currentLevelData;
    }

    this.filterVisible = false;
  }

  onPopoverVisibleChange(visible: boolean) {
    if (!visible) {
      this.cancelFilter();
    } else {
      console.log('Popover is now visible');
    }
  }

  loadNextPage(): void {
    if (this.isLoading || this.noMoreData) {
      console.log("Already loading or no more data to load");
      return;
    }
    console.log("loadNextPage function called");

    this.isLoading = true;
    console.log("this is selected root folder into loadnext", this.parentFolderIdResource)

    let isLastPage = this.folderPaginationMap.get(this.parentFolderIdResource || null)?.isLastPage || false;
    let nextPage = this.folderPaginationMap.get(this.parentFolderIdResource || null)?.nextPage || this.currentPage + 1;
    console.log("this is nextPage", nextPage);
    this.currentPage = nextPage;

    this.lastRequestTime = localStorage.getItem('lastRequestTime');

    console.log("Current Page:", this.currentPage, "isLastPage :", isLastPage);

    //call the getResourceList function with updated page number
    if (!isLastPage) {
      // this.parentFolderIdResource = resourceId ? resourceId : this.getCurrentFolderId();
      this.getResources({ filters: [] });
    }
    else {
      console.log("Starting LoadNext Error printing ===========>")
      console.log("this.hasMore", this.hasMore);
      console.log("this.isLoading", this.isLoading);
      console.log("this.folderPaginationMap", this.folderPaginationMap);
      console.log("this.parentFolderIdResource", this.parentFolderIdResource);

      console.log("End LoadNext Error printing ===========>")

      this.isLoading = false;
      this.createNotification('info', '', 'No more data to load.');
      // this.folderNavigationStack.length > 1 && this.folderNavigationStack.pop() ;

    }



  }

  applySearch(value: any) {

    if (value.trim()) {
      this.searchTerm = value;
      this.currentPage = 1;
      this.getResources({ filters: [] }, "search");
    }

    console.log("this is value", value);
  }

  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;             // how far scrolled from top
    const scrollHeight = target.scrollHeight;       // full height of scrollable content
    const clientHeight = target.clientHeight;       // visible area

    // console.log('scrollTop:', scrollTop);
    // console.log('scrollHeight:', scrollHeight);
    // console.log('clientHeight:', clientHeight);
    console.log('Reached bottom?', scrollTop + clientHeight + 10 >= scrollHeight);

    if (scrollTop + clientHeight + 10 >= scrollHeight) {
      console.log('Reached bottom, loading next page...');
      console.log("this is isLoading", this.isLoading);
      console.log("this is showLoad", this.showLoad);
      console.log("this is hasMore", this.hasMore);
      if ((this.isLoading || this.showLoad) || !this.hasMore) {
        console.log('Loading or no more data, stopping');
        return;
      }
      this.loadNextPage();
    }
  }
   onScrollDown(event: Event): void {
    console.log("Event",event)
    // console.log("this is current page", this.currentPage, this.hasMore);
    // if ((this.isLoading || this.showLoad) || !this.hasMore) {
    //   console.log('Loading or no more data, stopping');
    //   return;
    // }
    // console.log("Before loadnext page");
  
    // // this.loadNextPage();

    // console.log("this is filtered Resource while scroll", this.filteredResourcess);
    
  }
  onSortChange(params): void {
    // 'sortInfo.key' is the column key (e.g., 'resourceName', 'dateCreated')
    // 'sortInfo.value' is the sort direction ('ascend', 'descend')

    console.log('Sort parmas:', params);
    const { pageSize, pageIndex, sort, filter } = params;
    const currentSort = sort.find(item => item.value !== null);
    let sortField = (currentSort && currentSort.key) || null;
    let sortOrder = (currentSort && currentSort.value) || null;

    sortOrder = sortOrder === 'ascend' ? 'asc' : sortOrder === 'descend' ? 'desc' : null;
    console.log("this is sortField", sortField);
    this.sortOrderR = sortOrder;
    this.sortField = sortField;

    // Reset to the first page and clear data
    this.currentPage = 1;
    this.filteredResourcess = [];
    this.resourceCache.clear();
    this.folderPaginationMap.clear();
    this.folderIndexMap.clear();
    this.hasMore = true;

    // Make the API call with the sorting parameters
    this.getResources({ filters: [] }, null);
  }

}
